export default function APIKeyNotFound(){return/*#__PURE__*/React.createElement("div",null,"API Key Not Found.");}